module.exports = __webpack_public_path__ + "increase-visit.svg?119522741c2f77c21fd579339565d5c6";